import { get } from "@utils/axios";

const api = "dashboard";

export const getDashboardDetails = () => {
  return get(`${api}/details`)
};
